import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7390e76c = () => interopDefault(import('../../../pages/app/index.vue' /* webpackChunkName: "pages/app/index" */))
const _435819b8 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _d94b1214 = () => interopDefault(import('../../../pages/app/bewertung/index.vue' /* webpackChunkName: "pages/app/bewertung/index" */))
const _fcae6896 = () => interopDefault(import('../../../pages/app/einstellungen.vue' /* webpackChunkName: "pages/app/einstellungen" */))
const _578cbd77 = () => interopDefault(import('../../../pages/app/evaluation/index.vue' /* webpackChunkName: "pages/app/evaluation/index" */))
const _5453cfff = () => interopDefault(import('../../../pages/app/expose/index.vue' /* webpackChunkName: "pages/app/expose/index" */))
const _71922806 = () => interopDefault(import('../../../pages/app/forgot-password.vue' /* webpackChunkName: "pages/app/forgot-password" */))
const _57f56bb4 = () => interopDefault(import('../../../pages/app/haftungsausschluss.vue' /* webpackChunkName: "pages/app/haftungsausschluss" */))
const _54d10343 = () => interopDefault(import('../../../pages/app/liveparser.vue' /* webpackChunkName: "pages/app/liveparser" */))
const _10d7f098 = () => interopDefault(import('../../../pages/app/loading.vue' /* webpackChunkName: "pages/app/loading" */))
const _e041a13e = () => interopDefault(import('../../../pages/app/login.vue' /* webpackChunkName: "pages/app/login" */))
const _1551632b = () => interopDefault(import('../../../pages/app/objekt-radar/index.vue' /* webpackChunkName: "pages/app/objekt-radar/index" */))
const _b9e4f77a = () => interopDefault(import('../../../pages/app/portfolio/index.vue' /* webpackChunkName: "pages/app/portfolio/index" */))
const _439ba1db = () => interopDefault(import('../../../pages/app/register.vue' /* webpackChunkName: "pages/app/register" */))
const _1b38044f = () => interopDefault(import('../../../pages/app/reset-rassword.vue' /* webpackChunkName: "pages/app/reset-rassword" */))
const _14b6f5bc = () => interopDefault(import('../../../pages/app/verification-email.vue' /* webpackChunkName: "pages/app/verification-email" */))
const _db2a7568 = () => interopDefault(import('../../../pages/app/objekt-radar/abonnement.vue' /* webpackChunkName: "pages/app/objekt-radar/abonnement" */))
const _7c3fc85b = () => interopDefault(import('../../../pages/app/objekt-radar/details.vue' /* webpackChunkName: "pages/app/objekt-radar/details" */))
const _afb0f1ea = () => interopDefault(import('../../../pages/app/objekt-radar/subscription-done.vue' /* webpackChunkName: "pages/app/objekt-radar/subscription-done" */))
const _7003d597 = () => interopDefault(import('../../../pages/app/objekt-radar/testzeitraum_abgelaufen.vue' /* webpackChunkName: "pages/app/objekt-radar/testzeitraum_abgelaufen" */))
const _981dc55e = () => interopDefault(import('../../../pages/app/objekt-radar/testzeitraum_aktivieren.vue' /* webpackChunkName: "pages/app/objekt-radar/testzeitraum_aktivieren" */))
const _5fefd14d = () => interopDefault(import('../../../pages/app/subscription/register.vue' /* webpackChunkName: "pages/app/subscription/register" */))
const _b37873b2 = () => interopDefault(import('../../../pages/app/expose/_id.vue' /* webpackChunkName: "pages/app/expose/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/app",
    component: _7390e76c,
    name: "app___default"
  }, {
    path: "/at",
    component: _435819b8,
    name: "index___at"
  }, {
    path: "/app/bewertung",
    component: _d94b1214,
    name: "app-bewertung___default"
  }, {
    path: "/app/einstellungen",
    component: _fcae6896,
    name: "app-einstellungen___default"
  }, {
    path: "/app/evaluation",
    component: _578cbd77,
    name: "app-evaluation___default"
  }, {
    path: "/app/expose",
    component: _5453cfff,
    name: "app-expose___default"
  }, {
    path: "/app/forgot-password",
    component: _71922806,
    name: "app-forgot-password___default"
  }, {
    path: "/app/haftungsausschluss",
    component: _57f56bb4,
    name: "app-haftungsausschluss___default"
  }, {
    path: "/app/liveparser",
    component: _54d10343,
    name: "app-liveparser___default"
  }, {
    path: "/app/loading",
    component: _10d7f098,
    name: "app-loading___default"
  }, {
    path: "/app/login",
    component: _e041a13e,
    name: "app-login___default"
  }, {
    path: "/app/objekt-radar",
    component: _1551632b,
    name: "app-objekt-radar___default"
  }, {
    path: "/app/portfolio",
    component: _b9e4f77a,
    name: "app-portfolio___default"
  }, {
    path: "/app/register",
    component: _439ba1db,
    name: "app-register___default"
  }, {
    path: "/app/reset-rassword",
    component: _1b38044f,
    name: "app-reset-rassword___default"
  }, {
    path: "/app/verification-email",
    component: _14b6f5bc,
    name: "app-verification-email___default"
  }, {
    path: "/at/app",
    component: _7390e76c,
    name: "app___at"
  }, {
    path: "/app/objekt-radar/abonnement",
    component: _db2a7568,
    name: "app-objekt-radar-abonnement___default"
  }, {
    path: "/app/objekt-radar/details",
    component: _7c3fc85b,
    name: "app-objekt-radar-details___default"
  }, {
    path: "/app/objekt-radar/subscription-done",
    component: _afb0f1ea,
    name: "app-objekt-radar-subscription-done___default"
  }, {
    path: "/app/objekt-radar/testzeitraum_abgelaufen",
    component: _7003d597,
    name: "app-objekt-radar-testzeitraum_abgelaufen___default"
  }, {
    path: "/app/objekt-radar/testzeitraum_aktivieren",
    component: _981dc55e,
    name: "app-objekt-radar-testzeitraum_aktivieren___default"
  }, {
    path: "/app/subscription/register",
    component: _5fefd14d,
    name: "app-subscription-register___default"
  }, {
    path: "/at/app/bewertung",
    component: _d94b1214,
    name: "app-bewertung___at"
  }, {
    path: "/at/app/einstellungen",
    component: _fcae6896,
    name: "app-einstellungen___at"
  }, {
    path: "/at/app/evaluation",
    component: _578cbd77,
    name: "app-evaluation___at"
  }, {
    path: "/at/app/expose",
    component: _5453cfff,
    name: "app-expose___at"
  }, {
    path: "/at/app/forgot-password",
    component: _71922806,
    name: "app-forgot-password___at"
  }, {
    path: "/at/app/haftungsausschluss",
    component: _57f56bb4,
    name: "app-haftungsausschluss___at"
  }, {
    path: "/at/app/liveparser",
    component: _54d10343,
    name: "app-liveparser___at"
  }, {
    path: "/at/app/loading",
    component: _10d7f098,
    name: "app-loading___at"
  }, {
    path: "/at/app/login",
    component: _e041a13e,
    name: "app-login___at"
  }, {
    path: "/at/app/objekt-radar",
    component: _1551632b,
    name: "app-objekt-radar___at"
  }, {
    path: "/at/app/portfolio",
    component: _b9e4f77a,
    name: "app-portfolio___at"
  }, {
    path: "/at/app/register",
    component: _439ba1db,
    name: "app-register___at"
  }, {
    path: "/at/app/reset-rassword",
    component: _1b38044f,
    name: "app-reset-rassword___at"
  }, {
    path: "/at/app/verification-email",
    component: _14b6f5bc,
    name: "app-verification-email___at"
  }, {
    path: "/at/app/objekt-radar/abonnement",
    component: _db2a7568,
    name: "app-objekt-radar-abonnement___at"
  }, {
    path: "/at/app/objekt-radar/details",
    component: _7c3fc85b,
    name: "app-objekt-radar-details___at"
  }, {
    path: "/at/app/objekt-radar/subscription-done",
    component: _afb0f1ea,
    name: "app-objekt-radar-subscription-done___at"
  }, {
    path: "/at/app/objekt-radar/testzeitraum_abgelaufen",
    component: _7003d597,
    name: "app-objekt-radar-testzeitraum_abgelaufen___at"
  }, {
    path: "/at/app/objekt-radar/testzeitraum_aktivieren",
    component: _981dc55e,
    name: "app-objekt-radar-testzeitraum_aktivieren___at"
  }, {
    path: "/at/app/subscription/register",
    component: _5fefd14d,
    name: "app-subscription-register___at"
  }, {
    path: "/",
    component: _435819b8,
    name: "index___default"
  }, {
    path: "/at/app/expose/:id",
    component: _b37873b2,
    name: "app-expose-id___at"
  }, {
    path: "/app/expose/:id",
    component: _b37873b2,
    name: "app-expose-id___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
